import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function PurchaseSection() {
  return <section id="compra" className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto scroll-mt-10" data-id="element-220">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="bg-gradient-to-b from-zinc-900 to-zinc-950 border-2 border-amber-500/50 rounded-3xl p-8 md:p-12 text-center relative shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-221">
        <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-amber-500 text-zinc-950 px-6 py-2 rounded-full font-bold uppercase tracking-wider text-sm shadow-lg" data-id="element-222">
          Oferta Especial
        </div>

        <div className="mb-8" data-id="element-223">
          <p className="text-zinc-400 font-medium mb-2 uppercase tracking-widest text-sm" data-id="element-224">
            Valor del plan completo
          </p>
          <div className="text-5xl md:text-6xl font-heading font-black text-white mb-2" data-id="element-225">
            💰 HOY: <span className="text-amber-400" data-id="element-226">$19.990 ARS</span>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-10 text-zinc-300 font-medium" data-id="element-227">
          <span className="bg-zinc-800/50 px-4 py-2 rounded-lg border border-zinc-700" data-id="element-228">
            Pago único.
          </span>
          <span className="bg-zinc-800/50 px-4 py-2 rounded-lg border border-zinc-700" data-id="element-229">
            Descarga inmediata.
          </span>
          <span className="bg-zinc-800/50 px-4 py-2 rounded-lg border border-zinc-700" data-id="element-230">
            Sin suscripciones.
          </span>
        </div>

        <a href="https://barberoscheckout.ebookditales.com/cart/51844014407963:1" target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-231">
          <Button size="xl" fullWidth className="shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)]" data-id="element-232">
            ACCEDER AL PLAN AHORA
          </Button>
        </a>

        <p className="mt-6 text-sm text-zinc-500" data-id="element-233">
          Pago 100% seguro. Acceso inmediato tras la compra.
        </p>
      </motion.div>
    </section>;
}